module.exports = __webpack_public_path__ + "img/nav-right-search-below-mazda.4cdccb6e.png";